<template>
    <div>
        <div class="dataListBox" v-loading="dataListLoading">
            <div 
                class="dataList" 
                v-for="(item,index) in dataList" 
                :key="index"
                @click="dataListClick(item)">
                <div class="dataListTitle">
                    <span v-html="item.title"></span>
                </div>
                <div class="dataListQT">
                    <div class="dataListA" v-if="propsData1.name=='专题'">
                        <img :src="imgObj.icon_editor" alt="">
                        <div class="authorText">{{ item.editor }}</div>
                    </div>
                    <div class="dataListA" v-if="propsData1.name=='专题'">
                        <img :src="imgObj.icon_editor" alt="">
                        <div class="authorText">{{ item.author }}</div>
                    </div>
                    <div class="dataListAuthor" v-if="propsData1.name!='稽查案例'&&propsData1.name!='税率'">
                        <div v-if="propsData1.name=='案例'">
                            <img :src="imgObj.icon_editor" alt="">
                            <div class="authorText">{{ item.editor }}</div>
                        </div>
                        <div v-if="propsData1.name=='答疑'||propsData1.name=='解读'">
                            <img :src="imgObj.icon_author" alt="">
                            <div class="authorText">{{ item.author }}</div>
                        </div>
                        <div v-if="propsData1.name=='专题'">
                            <img :src="imgObj.icon_author" alt="">
                            <div class="authorText">{{ item.xlfwName }}</div>
                        </div>
                    </div>
                    <div class="dataListTime">
                        <img :src="imgObj.icon_time" alt="">
                        <div class="authorText">{{ item.publishDate.slice(0,10) }}</div>
                    </div>
                </div>
            </div>

            <!--分页-->
            <div class="fenyeBox">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page.sync="page"
                    :page-size="this.size"
                    layout="total, prev, pager, next,jumper"
                    :total="total"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>

//引入接口
import { lawSearch } from '@/api/api.js'



import icon_time from "@/assets/images/icon/time.png"
import icon_author from "@/assets/images/icon/author.png"
import icon_editor from "@/assets/images/icon/editor.png"




export default {
    name:'',
    props:['sendData'],
    data(){
        return{
            imgObj:{
                icon_time,
                icon_author,
                icon_editor
            },
            dataListLoading:false,
            page:1,
            size:10,
            total:0,
            dataList:[],
            propsData1:{},
            specialType:false,
        }
    },
    mounted(){
        this.propsData1 = this.$props.sendData
        this.getStart(this.propsData1)
    },
    methods:{
        //开始函数
        getStart(obj){
            this.page = 1;
            //接收参数
            this.propsData1 = obj;
            //console.log(this.propsData1)
            //console.log(obj);
            if(obj.special == true){
                this.specialType = true;
            }else{
                this.specialType = false;
            }
            //获取数据
            this.getDataList();
        },
        //获取数据列表
        getDataList(){
            this.dataListLoading = true;
            let data = {
                page: this.page, 
                size: this.size, 
                categoryId: this.propsData1.listId,
                states:[],
                tagIds:[],
                
            } 
            if(this.specialType == true){
                data.sortType = 'sort'
            }else{
                data.sortType = ''
            }
  
            //判断是否传递了关键词 
            if(this.propsData1.searchType==3){
                data.startPublicDate = this.propsData1.startPublicDate
                data.endPublicDate = this.propsData1.endPublicDate
            }else{
                if(this.propsData1.inputValue&&this.propsData1.inputValue!==''){
                    let key = this.propsData1.searchType==0?'keywordExact':this.propsData1.searchType==1?'title':'articleNo'
                    data[key] = this.propsData1.inputValue
                }
            }

            lawSearch(data).then(res => {
                //console.log(res)
                this.dataList = res.data.data.contents
                this.total = res.data.data.count
                this.dataListLoading = false;
            })
        },
        //分页改变
        handleCurrentChange(v){
            this.page = v
            this.getDataList();
        },
        //进入详情
        dataListClick(item){
            //console.log(item)
            let Detail = this.$router.resolve({
                path: '/content',
                query: {
                    contentId: item.id,
                    keyWord: this.propsData1.searchType==0||this.propsData1.searchType==1?this.propsData1.inputValue:'',
                    searchType: 1,
                    listId: this.propsData1.listId,
                },
            })
          window.open(Detail.href, '_blank')
        }
    }
}
</script>

<style lang="scss" scoped>
.dataListBox{
    width:100%;
    overflow: hidden;
    box-sizing: border-box;
    padding:0 20px;
    .dataList{
        width:100%;
        overflow: hidden;
        min-height:84px;
        border-bottom:1px solid #D8D8D8;
        box-sizing: border-box;
        padding-bottom:20px;
        cursor: pointer;
        .dataListTitle{
            margin-top:12px;
            min-height: 24px;
            line-height: 24px;
            color:#3D3D3D;
        }
        .dataListQT{
            width:100%;
            height:16px;
            margin-top:10px;
            font-weight: 400;
            font-size: 14px;
            color: #888888;
            img{
                width:16px;
                height:16px;
                position: relative;
                top:2px;
                margin-right:2px;
            }
            .dataListA{
                width:100%;
                margin-bottom:6px;
            }
            .dataListAuthor{
                min-width:calc(50%);
                height:16px;
                float:left;
                margin-right:16px;
            }
            .dataListTime{
                min-width:120px;
                height:16px;
                float:left;
            }
            .authorText{
                display: inline-block;
                line-height: 16px;
            }
            
        }
    }
}

.fenyeBox{
    background: #fff;
    text-align: center;
    padding:10px 0;
}
</style>